import React, { Component } from "react";
import styles from "./winterUnits.module.scss";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { withAuth } from "../../../shared/containers/containerAuth";
import { withWinter } from "../../../shared/containers/containerWinter";

class WinterGroups extends Component {
  componentDidMount() {
    const { data, onGetWinterGroups } = this.props;

    if (data.permissions.includes(38001)) {
      onGetWinterGroups();
    }
  }

  componentWillUnmount() {
    this.props.onSelectWinterGroup(null);
  }

  render() {
    const { data } = this.props;

    if (!data.permissions.includes(38001)) {
      return null;
    }

    const { winterGroups, onSelectWinterGroup, selectedWinterGroup } = this.props;

    return (
      <div className={styles.witerGroupsContainer}>
        {winterGroups.map((winterGroup) => {
          return (
            <div
              className={styles.witerGroupItem}
              key={winterGroup.id}
              onClick={(e) => {
                e.stopPropagation();
                onSelectWinterGroup(winterGroup);
              }}
            >
              {selectedWinterGroup !== null && winterGroup.id === selectedWinterGroup.id ? (
                <div
                  className={styles.witerGroupItemClose}
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelectWinterGroup(null);
                  }}
                >
                  <HighlightOffIcon  fontSize="small"/>
                </div>
              ) : null}

              <div>{winterGroup.title}</div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default withWinter(withAuth(React.memo(WinterGroups)));
